import React from 'react';
import { Row, Select } from 'antd';
import PropTypes from 'prop-types';

const options = [
  {
    value: 'dropdown',
    label: 'Dropdown',
  },
  {
    value: 'radio',
    label: 'Radio',
  },
  {
    value: 'checkbox',
    label: 'Checkbox',
  },
];

const layoutOptions = [
  {
    value: 'horizontal',
    label: 'Horizontal',
  },
  {
    value: 'vertical',
    label: 'Vertical',
  },
];

export default function DropdownFieldStyleSelect({
  value,
  onChange,
  layout,
  onLayoutChange,
  disabled,
}) {
  const showLayoutOptions = value === 'radio' || value === 'checkbox';

  return (
    <>
      <Row style={{ marginTop: 15 }}>
        Styling options:
      </Row>
      <Row style={{ marginTop: 5 }}>
        <Select
          style={{ width: 350 }}
          options={options}
          value={value}
          defaultValue={options[0].value}
          optionFilterProp="label"
          onChange={onChange}
        />
      </Row>
      {showLayoutOptions && (
        <>
          <Row style={{ marginTop: 15 }}>
            Layout:
          </Row>
          <Row style={{ marginTop: 5 }}>
            <Select
              style={{ width: 350 }}
              options={layoutOptions}
              value={layout}
              defaultValue={layoutOptions[0].value}
              optionFilterProp="label"
              onChange={onLayoutChange}
              disabled={disabled}
            />
          </Row>
        </>
      )}
    </>
  );
}

DropdownFieldStyleSelect.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  layout: PropTypes.string,
  onLayoutChange: PropTypes.func,
  disabled: PropTypes.bool.isRequired,
};

DropdownFieldStyleSelect.defaultProps = {
  value: 'dropdown',
  layout: 'vertical',
  onLayoutChange: () => {},
};
